import { render, staticRenderFns } from "./FormVerifyEmail.vue?vue&type=template&id=fe6c2f0e"
import script from "./FormVerifyEmail.vue?vue&type=script&lang=js"
export * from "./FormVerifyEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports